import { AuthInterceptor } from './interceptors/auth-interceptor';
import { BavelLoaderComponent } from './components/bavel-loader/bavel-loader.component';
import { BlockUIModule } from 'primeng/blockui';
import { BrowserCompatibilityGuard } from './guards/compatibility-guard.service';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CustomFormatDatePipe } from '@app/pipes/custom-format-date.pipe';
import { CustomFormatNumberPipe } from '@app/pipes/custom-format-number.pipe';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NotificationsService } from '@shared/services/notifications.service';
import { PanelModule } from 'primeng/panel';
import { PendingInvoiceBannerComponent } from '@shared/components/pending-invoice-banner/pending-invoice-banner.component';
import { PaymentDetailBillToComponent } from '@app/payment-detail/components/bill-to/payment-detail-bill-to.component';
import { PaymentDetailCommentComponent } from '@app/payment-detail/components/comment/payment-detail-comment.component';
import { PaymentDetailComponent } from '@app/payment-detail/components/main/payment-detail.component';
import {
  PaymentDetailCryptaInfoComponent
} from '@app/payment-detail/components/crypta-info/payment-detail-crypta-info.component';
import {
  PaymentDetailProcessingRulesComponent
} from '@app/payment-detail/components/processing-rules/payment-detail-processing-rules.component';
import {
  PaymentDetailReferencesComponent
} from '@app/payment-detail/components/references/payment-detail-references.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { TranslateModule } from '@ngx-translate/core';
import { UserProfileResolverService } from './services/user-profile-resolver.service';
import { PasswordModule } from 'primeng/password';
import { KnobModule } from 'primeng/knob';
import { IUsersService } from '@shared/interfaces/users-service.interface';
import { Auth0UsersService } from '@shared/services/auth0-users.service';
import { AccountCompleteProfileComponent } from "@shared/components/complete-profile/account-complete-profile.component";
import { IdleWarningPopupComponent } from './components/idle-warning-popup/idle-warning-popup.component';
import {
  LegacyDomainNoticeBannerComponent
} from "@shared/components/legacy-domain-notice-banner/legacy-domain-notice-banner.component";
import { Drawer } from "primeng/drawer";
import { Message } from "primeng/message";
import { TooltipModule } from 'primeng/tooltip';

const PROVIDERS = [
  AuthInterceptor,
  AuthInterceptor,
  BrowserCompatibilityGuard,
  NotificationsService,
  UserProfileResolverService,
  {
    provide: IUsersService,
    useClass: Auth0UsersService
  },
];

const COMPONENTS = [
  BavelLoaderComponent,
  CustomFormatDatePipe,
  CustomFormatNumberPipe,
  PaymentDetailBillToComponent,
  PaymentDetailCommentComponent,
  PaymentDetailComponent,
  PendingInvoiceBannerComponent,
  PaymentDetailCryptaInfoComponent,
  PaymentDetailProcessingRulesComponent,
  PaymentDetailReferencesComponent,
  AccountCompleteProfileComponent,
  IdleWarningPopupComponent,
  LegacyDomainNoticeBannerComponent
];

@NgModule({
  imports: [
    BlockUIModule,
    ButtonModule,
    CheckboxModule,
    CommonModule,
    ConfirmDialogModule,
    DatePickerModule,
    DialogModule,
    FloatLabelModule,
    FormsModule,
    PasswordModule,
    ReactiveFormsModule,
    InputNumberModule,
    InputTextModule,
    PanelModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    SelectModule,
    TextareaModule,
    TranslateModule,
    KnobModule,
    Drawer,
    Message
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    BavelLoaderComponent,
    BlockUIModule,
    ButtonModule,
    CheckboxModule,
    ConfirmDialogModule,
    CustomFormatDatePipe,
    CustomFormatNumberPipe,
    DatePickerModule,
    DialogModule,
    FloatLabelModule,
    FormsModule,
    ReactiveFormsModule,
    InputNumberModule,
    InputTextModule,
    PaymentDetailComponent,
    PendingInvoiceBannerComponent,
    ProgressSpinnerModule,
    RadioButtonModule,
    SelectModule,
    TooltipModule,
    TranslateModule,
    AccountCompleteProfileComponent,
    IdleWarningPopupComponent,
    LegacyDomainNoticeBannerComponent
  ]
})

export class BavelSharedModule {
  public static forRoot(): ModuleWithProviders<BavelSharedModule> {
    return {
      ngModule: BavelSharedModule,
      providers: [...PROVIDERS]
    };
  }
}
